import React, { useRef, useState } from 'react';

import useWindowSize from 'hooks/use-windowSize';

import { Radar } from "react-chartjs-2";

import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
} from 'chart.js';

import RadarCchartImage140 from '@core/assets/images/radar-chart-140.png';
import RadarChartImage from '@core/assets/images/radar-chart-background.png';
import RadarChartReportImage from '@core/assets/images/radar-chart-report.png';
import RadarChartMobileImage from '@core/assets/images/radar-chart-mobile.png';


const RadarChartCompetency = ({ chartData, marketData, isSmall = false, imageSize = null }) => {
    const { mobileDevice } = useWindowSize();

    ChartJS.register(RadialLinearScale,
        PointElement,
        LineElement,
        Filler,
        Tooltip,
        Legend,
    );
    const RadarData = {
        labels: [["IT Solutions"], ["Quality", "Control"], ["Quality", "Assurance"],
        ["Supply Chain", "Management"], "Manufacturing", ["Regulatory", "Affairs"], ["Marketing", "and Sales"], ["Professional", "Development"]],
        datasets: [
            {
                // label: "March",
                strokeColor: "rgba(220,220,220,1)",
                // backgroundColor: "rgba(255, 106, 209, 0.30)",
                fill: false,
                lineWidth: 1,
                borderColor: "#65829F",
                pointBackgroundColor: "#65829F",
                poingBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(34, 202, 236, 1)",
                pointRadius: 1,
                data: [10, 10, 10, 10, 10, 10, 10, 10],
            },
            {
                label: "User Score",
                strokeColor: "rgba(220,220,220,1)",
                backgroundColor: "rgba(255, 106, 209, 0.30)",
                borderColor: "#BB3A90",
                pointBackgroundColor: "#BB3A90",
                poingBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(34, 202, 236, 1)",
                pointRadius: 1.5,
                data: [
                    chartData?.it_solutions,
                    chartData?.quality_control,
                    chartData?.quality_assurance,
                    chartData?.supply_chain_management,
                    chartData?.manufacturing,
                    chartData?.regulatory_affairs,
                    chartData?.marketing_and_sales,
                    chartData?.professional_development
                ],
            },
            {
                label: "Market Score",
                strokeColor: "rgba(220,220,220,1)",
                backgroundColor: "rgba(24, 187, 168, 0.30)",
                borderColor: "#18BBA8",
                pointBackgroundColor: "#18BBA8",
                poingBorderColor: "#fff",
                pointHoverBackgroundColor: "#fff",
                pointHoverBorderColor: "rgba(34, 202, 236, 1)",
                pointRadius: 1.5,
                data: [
                    marketData?.it_solutions,
                    marketData?.quality_control,
                    marketData?.quality_assurance,
                    marketData?.supply_chain_management,
                    marketData?.manufacturing,
                    marketData?.regulatory_affairs,
                    marketData?.marketing_and_sales,
                    marketData?.professional_development
                ],
            },
        ]
    };

    const image = new Image();
    if (imageSize === null) {
        if (mobileDevice || isSmall) {
            image.src = RadarChartMobileImage.src;
        }
        else
            image.src = RadarChartReportImage.src;
    } else {
        image.src = RadarCchartImage140.src;
    }

    const plugin = {
        id: 'custom_canvas_background_image',
        beforeDraw: (chart) => {
            if (image.complete) {
                const ctx = chart.ctx;
                const { top, left, width, height } = chart.chartArea;
                const x = (left + width / 2 - image.width / 2);
                const y = top + height / 2 - image.height / 2;
                ctx.drawImage(image, x, y);
            } else {
                image.onload = () => {
                    if (chart.ctx) chart.draw();
                };
            }
        },
        afterLayout: chart => {
            chart.getDatasetMeta(0).rScale._pointLabelItems.forEach(o => o.textAlign = 'center');
        }
    };

    const RadarOptions = {

        scale: {
            min: -1,
            max: 10,
            // backdropColor: '#000',
            backdropSize: 20,
            strokeColor: "rgba(220,220,220,1)",
            // display: false,
            // backgroundColor: '#000',            
            ticks: {
                beginAtZero: true,
                stepSize: 2,
                display: false,
            },
        },
        scales: {
            r: {
                angleLines: {
                    display: false,
                    color: '#A8BCCC',
                    borderDash: [6, 5],
                    borderDashOffset: 100
                },
                grid: {
                    display: false,
                },
                pointLabels: {
                    color: ((c) => {
                        return '#403f3f';
                    }),
                    padding: mobileDevice || isSmall ? 27 : 40,
                    font: {
                        size: mobileDevice || isSmall ? 9 : 13,
                        weight: 500,
                        family: 'Montserrat',
                    },
                },
                ticks: {
                    display: false,
                }
            }
        },
        plugins: {
            legend: {       
                display: true,
                position: 'bottom',
                labels: {
                    color: '#403f3f',
                    boxWidth: 10,
                    boxHeight: 10,
                    padding: 16,
                    filter: (legendItem, chartData) => {
                        const dataset = chartData?.datasets?.[legendItem?.datasetIndex];
                        const datasetLabel = dataset?.label;
                        const hasValidLabel = typeof datasetLabel === 'string' && datasetLabel.trim().length > 0;
                        const hasNonNullData = Array.isArray(dataset?.data) && dataset.data.some((value) => value !== null && value !== undefined);

                        return hasValidLabel && hasNonNullData;
                    },
                    font: {
                        size: mobileDevice || isSmall ? 10 : 12,
                        family: 'Montserrat',
                        weight: 500,
                    },
                }
            },
            tooltip: { enabled: false },
        },
        elements: {
            line: {
                borderWidth: 1
            }
        },
        animation: {
            duration: 0
        }

    };

    return (
        <div className='' style={{ position: 'relative' }}>
            <Radar
                data={RadarData}
                plugins={[plugin]}
                options={RadarOptions}
            />
        </div >
    );
};

export default RadarChartCompetency;